import { Permissions } from "../Shared-ui/Types/Permission";

// Jwt service token key name
export const TokenKeyName = "access_token"
export const TokenKeyType = "token_type"
export const UserRole = "user_role"

export const PlayGroundSize = "sm"

// Base urls of api service
export const BaseUrl = process.env.REACT_APP_BASE_URL;


// Embed info text

export const EmbedInfoText = "Please save your secret key in a safe place since you won't be able to view it again. Keep it secure, as anyone with your API key can make requests on your behalf. If you do lose it, you'll need to generate a new one."



export const MetaBaseUrl = process.env.REACT_APP_META_BASE_URL;
export const ChatBaseUrl = process.env.REACT_APP_CHAT_BASE_URL;

// ZeaOne API Configuration
export const ZeaOneAppId = process.env.REACT_APP_ZEAONE_APP_ID || "ba3156f5-e56d-4672-894b-b4c655087847";
export const ZeaOneApiKey = process.env.REACT_APP_ZEAONE_API_KEY || "7371acedaba22c3d0cf68f89a934b3d44e0d51e8072e45867d242de909edc8ae";
export const ZeaOneBaseUrl = process.env.REACT_APP_ZEAONE_BASE_URL || "https://demo-zeaone.zeasale.com";

// redirect url
export const RedirectUrl = process.env.REACT_APP_REDIRECT_URL || "https://qa.zeaiq.com"

export const NotSelected = "notSelected"

export const DefaultGroupList: string[] = ["Human Resource", "Finance", "Development", "Design",]

export const ALLOWEDEXTENSION = ["txt", "doc", "docx", "xls", "xlsx", "csv", "pdf", "jpg", "png", "jpeg"];

export const SuperAdmin = "SuperAdmin"


export const personalEmailProviders = [
    'gmail.com',          // Google's email service
    'yahoo.com',          // Yahoo's email service
    'outlook.com',        // Microsoft's Outlook service
    'hotmail.com',        // Microsoft's Hotmail service (legacy of Outlook)
    'icloud.com',         // Apple's iCloud email service
    'aol.com',            // AOL's email service
    'msn.com',            // MSN's email service (owned by Microsoft)
    'zoho.com',           // Zoho's free email service
    'mail.com',           // A free email provider with custom domain options
    'protonmail.com',     // Secure email service based in Switzerland
    'gmx.com',            // A free email service from GMX (Global Mail eXchange)
    'tutanota.com',       // Secure email service focused on privacy
    'yandex.com',         // Russian search engine Yandex's email service
    'inbox.com',          // A free email provider (now mostly legacy)
    'fastmail.com',       // Paid but popular for personal use
    'rediffmail.com',     // Free email provider from India (Rediff)
    'mail.ru',            // Popular email provider in Russia
    'hushmail.com',       // Secure and private email service
    'runbox.com',         // Paid email service focused on privacy
    'lavabit.com',        // Privacy-focused email service (used by Edward Snowden)
    'tutamail.com',       // Email service focused on privacy
    'posteo.de',          // Privacy-focused email provider based in Germany
    'seznam.cz',          // Czech email provider
    'web.de',             // German email provider
    'bell.net',           // Bell Canada's email service
    'shaw.ca',            // Shaw Communications' email service
    'rogers.com',         // Rogers Communications' email service
    'cox.net',            // Cox Communications' email service
    'earthlink.net',      // Earthlink's free email service
    'charter.net',        // Charter Communications' email service (now part of Spectrum)
    'att.net',            // AT&T's email service
    'comcast.net',        // Comcast's email service (Xfinity)
    'verizon.net',        // Verizon's email service
    'sbcglobal.net',      // SBC Global (used by AT&T's legacy customers)
    'bright.net',         // BrightNet's email service (legacy)
    'free.fr',            // Free's email service (France)
];




export const DefaultPermission: Permissions = {
    createApiKey: false,
    deleteApiKey: false,
    viewApiKeyList: false,

    createAgent: false,
    deleteAgent: false,
    viewAgents: false,

    viewAllAgents: false,
    modifyAllAgents: false,

    uploadAgentFiles: false,
    deleteAgentFiles: false,


    createGroup: false,
    viewGroup: false,
    deleteGroup: false,

    createPrompt: false,
    viewPrompt: false,
    deletePrompt: false,

    createTemplate: false,
    viewTemplate: false,
    deleteTemplate: false,

    createRole: false,
    viewRole: false,
    deleteRole: false,
    updateRole: false,

    viewUser: false,
    updateUser: false,

    viewNewUser: false,

    viewChatLog: false,

    viewDashboard: false,

    viewAuditLogs: false,

    viewClientDetails: false,
    editClientDetails: false,

    deleteChatHistory: false
}



